import t from 'react-translate';
import { useContext } from 'react';
import { AngularServicesContext } from 'react-app';
import MentoringProgramContext from 'athena/components/mentoring-program/context';

import NvModal, { ModalType } from 'shared/components/nv-modal';
import AuthenticateIntegration from './authenticate-integration';
import { camelCase } from 'lodash';
import {
  AuthenticationStatus,
  IntegrationAuth,
  mappingIntegrationType,
  OauthIntegration,
} from 'redux/schemas/models/mentoring-program-sessions';
import { getAuthenticatedAccounts, getOAuthLink } from '../utils';
import { SessionTypes } from 'redux/schemas/models/live-event';
import { AuthenticationView, LocalStorageKeys } from '../..';

const getCleanedUrl = ($location: any) => {
  const currentUrl = `${$location.protocol()}://${$location.host()}/#!${$location.path()}${$location.hash()}`;
  const newUrl = currentUrl.replace(/([?&])authenticationView=\d+/, '$1');
  const cleanedUrl = newUrl.replace(/([?&])showSession=\d+/, '$1');
  const url = cleanedUrl.endsWith('?') || cleanedUrl.endsWith('&') ? cleanedUrl.slice(0, -1) : cleanedUrl;
  return url;
};

const getModalParams = (integrations: IntegrationAuth, sessionId: number, createMeetingPlan: boolean) => {
  const { source = [] } = integrations || {};
  const connectedAccounts = getAuthenticatedAccounts(integrations);
  const showSessionId = sessionId ? `&showSession=${sessionId}` : '';
  const showIntegrationsModal = source?.length === 2 && connectedAccounts.length === 0;

  let view = showIntegrationsModal ? AuthenticationView.SHOW_INTEGRATIONS : AuthenticationView.SHOW_SESSION;
  if (createMeetingPlan) {
    view = showIntegrationsModal ? AuthenticationView.SHOW_MEETING_PLAN_INTEGRATIONS : AuthenticationView.CREATE_MEETING_PLAN;
  }

  return `?authenticationView=${view}${showSessionId}`;
};

type EnableIntegrationsModalProps = {
  session: any;
  sessionId: number;
  integrations: any;
  createMeetingPlan: boolean;
  onClose: () => void;
};

const EnableIntegrationsModal = (props: EnableIntegrationsModalProps) => {
  const { session, sessionId, integrations, createMeetingPlan, onClose } = props;
  const { source = [] } = integrations || {};
  const { $location } = useContext(AngularServicesContext);
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id, mentorshipProgramEnrollment: enrollmentId } = mentoringProgram;

  const translationsBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.ENABLE_INTEGRATIONS_MODAL;

  const handleClick = (integration: string) => {
    const sessionType = integration === mappingIntegrationType.ZoomLiveSession ? SessionTypes.ZOOM : SessionTypes.MS_TEAMS;
    const showModalParams = getModalParams(integrations, sessionId, createMeetingPlan);
    const url = getCleanedUrl($location);
    const refererUrl = `${url}${showModalParams}`;
    const href = getOAuthLink({
      mentoringProgramId: id,
      sessionType,
      enrollmentId,
      refererUrl,
    });
    localStorage.setItem(LocalStorageKeys.redirection, 'true');
    localStorage.setItem(LocalStorageKeys.session, JSON.stringify(session));
    window.location.href = href;
  };

  const sections = source?.map((type: any) => {
    const camelType = camelCase(type);
    const integration: OauthIntegration = integrations[camelType];
    const isAuthenticated = integration.authenticatedStatus === AuthenticationStatus.AUTHENTICATED;
    const authenticationEmail = integration.authenticationEmail;

    return (
      <div key={type} className='d-flex flex-column'>
        <AuthenticateIntegration
          integration={type}
          isAuthenticated={isAuthenticated}
          authenticationEmail={authenticationEmail}
          onClick={handleClick}
        />
      </div>
    );
  });

  return (
    <NvModal
      type={ModalType.FIXED}
      doubleModal
      header={translationsBase.TITLE()}
      headerClassName='page-title'
      body={sections}
      height='unset'
      onClose={onClose}
    />
  );
};

export default EnableIntegrationsModal;
